import { render, staticRenderFns } from "./AddNumberPopup.vue?vue&type=template&id=974bfa96"
import script from "./AddNumberPopup.vue?vue&type=script&lang=js"
export * from "./AddNumberPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports